<div class="flex justify-center p-4">
  <mat-card class="w-full max-w-lg text-center !rounded-xl p-8">
    <mat-card-title class="!text-6xl font-bold text-blue-600">404</mat-card-title>
    <mat-card-subtitle class="!text-xl text-gray-700 mt-2">Page Not Found</mat-card-subtitle>
    <mat-card-content class="mt-6 text-gray-600">
      <p>Sorry, the page you are looking for does not exist or may have been moved.</p>

      <div *ngIf="redirectUri" class="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <p>We think we know where you wanted to go.</p>
        <p class="font-semibold mt-2">
          Redirecting you in {{ countdown }} seconds...
        </p>
      </div>
    </mat-card-content>
    <mat-card-actions class="!flex justify-center gap-4 mt-8">
      <ng-container *ngIf="redirectUri">
        <a mat-flat-button color="primary" [href]="redirectUri">Go Now</a>
        <button mat-stroked-button (click)="cancelRedirect()">Stay Here</button>
      </ng-container>

      <a *ngIf="!redirectUri" mat-flat-button color="primary" routerLink="/">Go to Homepage</a>
    </mat-card-actions>
  </mat-card>
</div>